// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

// Single source of truth for the id of the most-recent changelog entry.
//
// Both the real changelog content (`changelog.tsx`, whose top entry sets
// `id: latestChangelogId`) and the E2E fixture (`e2e/fixtures.ts`, whose
// "already seen" localStorage seed reads this value) import it, so the two can
// never drift. Keeping them locked is what stops the authenticated-layout
// changelog modal from popping over — and blocking — every E2E in a fresh
// browser context (see src/hooks/useChangelog.tsx).
//
// JSX-free on purpose: the Playwright fixture must be able to import this
// without pulling React into its bundle.
export const latestChangelogId = "cycle-dashboard-improvements"
